<template>
  <div id="GeoSearch">
    <b-field>
      <b-autocomplete
        custom-class="dtac-font"
        field="formatted_address"
        :placeholder="$t('register.search.placeholder')"
        :loading="isFetching"
        :data="autoCompleteData"
        @typing="getGeoSearchAutoComplete"
        @select="option => (selectedPlace = option)"
        @keyup.enter.native="searchButtonPressed"
      >
        <template slot-scope="props">
          <div class="media">
            <div class="media-left">
              <img width="24" src="../assets/customer_home.svg" />
            </div>
            <div class="media-content">
              {{ props.option.formatted_address }}
            </div>
          </div>
        </template>
      </b-autocomplete>
    </b-field>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import AlertManager from "@/managers/AlertManager";
import MapApiManager from "@/apis/MapApiManager";

export default {
  name: "GeoSearch",
  props: ["isSearch"],
  data() {
    return {
      autoCompleteData: [],
      isFetching: false,
      selectedPlace: null,
      searchKeyword: null
    };
  },
  watch: {
    isSearch: function(val) {
      if (val) {
        this.searchButtonPressed();
      }
    }
  },
  methods: {
    searchButtonPressed: function() {
      if (
        this.searchKeyword !== "" &&
        !this.validateNumberString(this.searchKeyword)
      ) {
        this.getSelectedPlaceDetail();
      } else if (this.validateLatLngFormat(this.searchKeyword)) {
        this.emitCoordinateToParent(this.searchKeyword);
      } else {
        this.emitErrorToParent();
      }
    },
    getGeoSearchAutoComplete: debounce(async function(keyword) {
      if (keyword) {
        this.searchKeyword = keyword;
        // If input is not string, assume that it's a lat lng format
        if (keyword === "" || this.validateNumberString(keyword)) {
          // If it's a lat lng format convert to coordinat and emit to parent component
          if (this.validateLatLngFormat(keyword)) {
            this.emitCoordinateToParent(keyword);
          }
          this.autoCompleteData = [];
        } else {
          // If input is string, convert it to lat lng format by geocoding
          this.isFetching = true;
          const autoCompleteResponse = await MapApiManager.requestAutoComplete(
            keyword
          );
          this.autoCompleteData = autoCompleteResponse;
          this.isFetching = false;
        }
      }
    }, 700),
    getSelectedPlaceDetail: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      if (this.selectedPlace && this.selectedPlace.location_id) {
        const locationResponse = await MapApiManager.requestLocationDetail(
          this.selectedPlace.location_id,
          this.$i18n.locale
        );
        this.extractGeoSearchLatLng(locationResponse);
      } else {
        const queryResponse = await MapApiManager.requestLocationId(
          this.searchKeyword
        );
        this.extractGeoSearchLatLng(queryResponse);
      }
      loadingComponent.close();
    },
    extractGeoSearchLatLng: function(geosearchResponse) {
      let LAT_LON =
        geosearchResponse.latitude + "," + geosearchResponse.longitude;
      if (this.validateLatLngFormat(LAT_LON)) {
        this.emitCoordinateToParent(LAT_LON);
      } else {
        AlertManager.showErrorSnackbar("Wrong Coordinate Format (Lat,Lng)");
      }
    },
    emitCoordinateToParent: function(inputLatLngString) {
      const LAT_LON = inputLatLngString.replace(/ /g, "").split(",");
      const coordinates = {
        lat: parseFloat(LAT_LON[0]),
        lng: parseFloat(LAT_LON[1])
      };
      this.$emit("search_result", coordinates);
    },
    emitErrorToParent: function() {
      const message = this.$t("alert.wrong_format_input");
      this.$emit("search_error", message);
    },
    validateLatLngFormat: function(coordinates) {
      const pattern = /^([-+]?)([\d]{1,2})(((\.)(\d+)(,)))(\s*)(([-+]?)([\d]{1,3})((\.)(\d+))?)$/g;
      return pattern.test(coordinates.replace(/ /g, ""));
    },
    validateNumberString: function(keyword) {
      const removeSpace = keyword.split(" ").join("");
      const removeDot = removeSpace.split(".").join("");
      const removeComma = removeDot.split(",").join("");
      const regex = /^\d+$/;
      return regex.test(removeComma);
    }
  }
};
</script>

<style></style>
